import { useState } from "react";
import { useSelector } from "react-redux";
import Clock from "react-live-clock";
import ProfilePopup from "../component/profilePopup";
import { useNavigate } from "react-router-dom";
import { LuPointer } from "react-icons/lu";
import { FaRegClock } from "react-icons/fa";
import { Drawer, Popover } from "antd";
import { IoMdAdd } from "react-icons/io";
import { MdHelpCenter } from "react-icons/md";
import { MdMailOutline } from "react-icons/md";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import Siders from "./sider";
const Header = () => {
  const navigate = useNavigate();
  const User = useSelector((state: any) => state.User.user);
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <div className="admin-header">
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div
          className="mobile-menu-btn"
          onClick={() => setDrawerOpen(true)}
        >
          <HiOutlineMenuAlt2 size={24} />
        </div>
        <div className="header-brand" onClick={() => navigate("/Auth")}>
          <span className="brand-title">Suprabhaatham Admin</span>
          <span className="version-badge">V2</span>
        </div>
      </div>

      <div className="header-actions">
        <Popover
          content={
            <div className="quick-actions">
              {User?.user_access?.includes(1) ? (
                <div
                  className="quick-action-item"
                  onClick={() => navigate("/Auth/home/news")}
                >
                  <IoMdAdd size={16} color="#0055a6" />
                  <span>Create News</span>
                </div>
              ) : null}

              {User?.user_access?.includes(23) ? (
                <div
                  className="quick-action-item"
                  onClick={() => navigate("/Auth/Article/createForm")}
                >
                  <IoMdAdd size={16} color="#0055a6" />
                  <span>Create Articles</span>
                </div>
              ) : null}

              {User?.user_access?.includes(24) ? (
                <div
                  className="quick-action-item"
                  onClick={() => navigate("/Auth/editorial/createform")}
                >
                  <IoMdAdd size={16} color="#0055a6" />
                  <span>Create Editorial</span>
                </div>
              ) : null}

              {User?.user_access?.includes(7) ? (
                <div
                  className="quick-action-item"
                  onClick={() => navigate("/Auth/EpaperForm/create")}
                >
                  <IoMdAdd size={16} color="#0055a6" />
                  <span>Add E-Paper</span>
                </div>
              ) : null}
            </div>
          }
          trigger="click"
          placement="bottomLeft"
        >
          <button className="header-btn">
            <LuPointer size={14} />
            <span>Quick</span>
          </button>
        </Popover>

        <div style={{ width: 120 }} className="header-time">
          <FaRegClock size={14} />
          <Clock format={"h:mm:ss A"} ticking={true} />
        </div>

        <Popover
          content={
            <a href="mailto:contact@bairuhatech.com" className="support-link">
              <MdMailOutline size={16} color="#0055a6" />
              <span>Connect Support</span>
            </a>
          }
          trigger="hover"
          placement="bottom"
        >
          <button className="header-btn help-btn">
            <MdHelpCenter size={18} color="#6c757d" />
          </button>
        </Popover>

        <div className="user-profile">
          <div className="user-info">
            <div className="user-name">{User.username}</div>
            <div className="user-email">{User.email}</div>
          </div>
          <ProfilePopup />
        </div>
      </div>
      <Drawer
        placement="left"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={130}
        bodyStyle={{ padding: 0 }}
        headerStyle={{ display: "none" }}
      >
        <div onClick={() => setDrawerOpen(false)}>
          <Siders />
        </div>
      </Drawer>
    </div>
  );
};

export default Header;
